import React, { useState, useEffect, useRef } from "react";
import "./index.css";
import AnimatedCounter from "../Shared/AnimatedCounter";

import section1Manufacturingfacilityhero from "../assests/ManufacturingQualityImages/section1Manufacturingfacilityhero.png";
import section2img from "../assests/HomeImg/section2-img.svg";

import manufacturingQualityMapSection2 from "../assests/ManufacturingQualityImages/manufacturingQualityMapSection2.png";
import manufacturingNetworkHighlightIcons from "../assests/ManufacturingQualityImages/manufacturingNetworkHighlightIcons.svg";
import manufacturingQualitySection2CertsListIcon from "../assests/ManufacturingQualityImages/manufacturingQualitySection2CertsList.svg";

import ESFlag from "../assests/ManufacturingQualityImages/ESFlag.png";
import BRFlag from "../assests/ManufacturingQualityImages/BRFlag.png";
import TRFlag from "../assests/ManufacturingQualityImages/TRFlag.png";
import USFlag from "../assests/ManufacturingQualityImages/USFlag.png";

import manufacturingQualityDiversifiedIcon from "../assests/ManufacturingQualityImages/manufacturingQualityDiversifiedIcon.svg";
import manufacturingQualityGlobalIcon from "../assests/ManufacturingQualityImages/manufacturingQualityGlobalIcon.svg";
import manufacturingQualityProvenIcon from "../assests/ManufacturingQualityImages/manufacturingQualityProvenIcon.svg";

import Icon1card1 from "../assests/ManufacturingQualityImages/Icon1card1.svg";
import Icon2card1 from "../assests/ManufacturingQualityImages/Icon2card1.svg";
import Icon3card1 from "../assests/ManufacturingQualityImages/Icon3card1.svg";
import Icon4card1 from "../assests/ManufacturingQualityImages/Icon4card1.svg";
import Icon5card1 from "../assests/ManufacturingQualityImages/Icon5card1.svg";
import Icon6card1 from "../assests/ManufacturingQualityImages/Icon6card1.svg";

import Icon1card2 from "../assests/ManufacturingQualityImages/Icon1card2.svg";
import Icon2card2 from "../assests/ManufacturingQualityImages/Icon2card2.svg";
import Icon3card2 from "../assests/ManufacturingQualityImages/Icon3card2.svg";
import Icon4card2 from "../assests/ManufacturingQualityImages/Icon4card2.svg";
import Icon5card2 from "../assests/ManufacturingQualityImages/Icon5card2.svg";
import Icon6card2 from "../assests/ManufacturingQualityImages/Icon6card2.svg";

import Icon1card3 from "../assests/ManufacturingQualityImages/Icon1card3.svg";
import Icon2card3 from "../assests/ManufacturingQualityImages/Icon2card3.svg";
import Icon3card3 from "../assests/ManufacturingQualityImages/Icon3card3.svg";
import Icon4card3 from "../assests/ManufacturingQualityImages/Icon4card3.svg";
import Icon5card3 from "../assests/ManufacturingQualityImages/Icon5card3.svg";
import Icon6card3 from "../assests/ManufacturingQualityImages/Icon6card3.svg";

import qualityStepsIcon1 from "../assests/ManufacturingQualityImages/qualityStepsIcon1.svg";
import qualityStepsIcon2 from "../assests/ManufacturingQualityImages/qualityStepsIcon2.svg";
import qualityStepsIcon3 from "../assests/ManufacturingQualityImages/qualityStepsIcon3.svg";
import qualityStepsIcon4 from "../assests/ManufacturingQualityImages/qualityStepsIcon4.svg";
import qualityStepsIcon5 from "../assests/ManufacturingQualityImages/qualityStepsIcon5.svg";
import qualityStepsIcon6 from "../assests/ManufacturingQualityImages/qualityStepsIcon6.svg";

import QualityControlsImage from "../assests/ManufacturingQualityImages/QualityControlsImage.png";

import infoCardsIcon1 from "../assests/ManufacturingQualityImages/infoCardsIcon1.svg";
import infoCardsIcon2 from "../assests/ManufacturingQualityImages/infoCardsIcon2.svg";
import infoCardsIcon3 from "../assests/ManufacturingQualityImages/infoCardsIcon3.svg";
import infoCardsIcon4 from "../assests/ManufacturingQualityImages/infoCardsIcon4.svg";

import FirstShotChemistryImage from "../assests/ManufacturingQualityImages/FirstShotChemistryImage.png";


import ViyashScientificUnit1Img1 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit1Img1.png";
import ViyashScientificUnit1Img2 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit1Img2.png";

import ViyashScientificUnit2Img1 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit2Img1.png";
import ViyashScientificUnit2Img2 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit2Img2.png";
import ViyashScientificUnit2Img3 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit2Img3.png";
import ViyashScientificUnit2Img4 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit2Img4.png";
import ViyashScientificUnit2Img5 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit2Img5.png";

import ViyashScientificUnit3Img1 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit3Img1.png";
import ViyashScientificUnit3Img2 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit3Img2.png";
import ViyashScientificUnit3Img3 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit3Img3.png";

import ViyashScientificUnit4Img1 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit4Img1.png";
import ViyashScientificUnit4Img2 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit4Img2.png";
import ViyashScientificUnit4Img3 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit4Img3.png";
import ViyashScientificUnit4Img4 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit4Img4.png";
import ViyashScientificUnit4Img5 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit4Img5.png";

import ViyashScientificUnit5Img1 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit5Img1.png";
import ViyashScientificUnit5Img2 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit5Img2.png";
import ViyashScientificUnit5Img3 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit5Img3.png";
import ViyashScientificUnit5Img4 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit5Img4.png";
import ViyashScientificUnit5Img5 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit5Img5.png";
import ViyashScientificUnit5Img6 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit5Img6.png";

import ViyashScientificUnit6Img1 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit6Img1.png";
import ViyashScientificUnit6Img2 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit6Img2.png";
import ViyashScientificUnit6Img3 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit6Img3.png";

import ViyashScientificUnit7Img1 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit7Img1.png";
import ViyashScientificUnit7Img2 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit7Img2.png";

import ViyashScientificUnit8Img1 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit8Img1.png";
import ViyashScientificUnit8Img2 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit8Img2.png";

import ViyashScientificUnit9Img1 from "../assests/ManufacturingQualityImages/FacilitiesImages/ViyashScientificUnit9Img1.png";

import AliviraVizagImg from "../assests/ManufacturingQualityImages/FacilitiesImages/AliviraVizagImg.png";

import AliviraAmbernathImg from "../assests/ManufacturingQualityImages/FacilitiesImages/AliviraAmbernathImg.png";


// ── Location Pin SVG (reused) ───────────────────────────────────────────────
const LocationIcon = ({ size = 14, color = "#6B7280" }) => (
    <svg
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 24 24"
        stroke={color}
        strokeWidth="2"
        className="manufacturing-quality-facility-card__address-icon"
    >
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
        />
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
        />
    </svg>
);

// ── Section Divider Decoration (reused) ─────────────────────────────────────
const SectionDivider = () => (
    <div className="manufacturing-quality-divider">
        <div className="manufacturing-quality-divider__line--orange" />
        <svg width="32" height="18" viewBox="0 0 40 22" fill="none">
            <circle cx="14" cy="11" r="10" fill="#0EA5E9" />
            <circle cx="26" cy="11" r="10" fill="#F97316" />
            <circle cx="14" cy="11" r="5" fill="#fff" />
            <circle cx="26" cy="11" r="5" fill="#fff" />
        </svg>
        <div className="manufacturing-quality-divider__line--blue" />
    </div>
);

// ── Facility Carousel Card ──────────────────────────────────────────────────
const FacilityCard = ({ facility, reverse }) => {
    const [current, setCurrent] = useState(0);
    const timerRef = useRef(null);

    const startTimer = () => {
        clearInterval(timerRef.current);
        timerRef.current = setInterval(() => {
            setCurrent((prev) => (prev + 1) % facility.images.length);
        }, 4000);
    };

    useEffect(() => {
        startTimer();
        return () => clearInterval(timerRef.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [facility.images.length]);

    const goTo = (i) => {
        setCurrent(i);
        startTimer();
    };

    const prev = () => {
        setCurrent(
            (c) => (c - 1 + facility.images.length) % facility.images.length
        );
        startTimer();
    };

    const next = () => {
        setCurrent((c) => (c + 1) % facility.images.length);
        startTimer();
    };

    /* ── image block ── */
    const imageBlock = (
        <div className="manufacturing-quality-facility-card__images">
            {/* Main carousel */}
            <div className="manufacturing-quality-facility-card__carousel">
                {facility.images.map((img, i) => (
                    <img
                        key={i}
                        src={img}
                        alt={facility.name}
                        className="manufacturing-quality-facility-card__carousel-img"
                        style={{ opacity: i === current ? 1 : 0 }}
                    />
                ))}

                {/* Prev arrow */}
                <button
                    onClick={prev}
                    className="manufacturing-quality-facility-card__arrow manufacturing-quality-facility-card__arrow--prev"
                    aria-label="Previous image"
                >
                    ‹
                </button>

                {/* Next arrow */}
                <button
                    onClick={next}
                    className="manufacturing-quality-facility-card__arrow manufacturing-quality-facility-card__arrow--next"
                    aria-label="Next image"
                >
                    ›
                </button>
            </div>

            {/* Thumbnails */}
            <div className="manufacturing-quality-facility-card__thumbs">
                {facility.images.map((img, i) => (
                    <div
                        key={i}
                        onClick={() => goTo(i)}
                        className={`manufacturing-quality-facility-card__thumb${i === current
                            ? " manufacturing-quality-facility-card__thumb--active"
                            : ""
                            }`}
                    >
                        <img
                            src={img}
                            alt=""
                            className="manufacturing-quality-facility-card__thumb-img"
                        />
                    </div>
                ))}
            </div>
        </div>
    );

    /* ── text block ── */
    const textBlock = (
        <div className="manufacturing-quality-facility-card__text">
            <h3 className="manufacturing-quality-facility-card__name">
                {facility.name}
            </h3>

            <div className="manufacturing-quality-facility-card__address">
                <LocationIcon size={14} color="#6B7280" />
                <span className="manufacturing-quality-facility-card__address-text">
                    {facility.address}
                </span>
            </div>

            {facility.points.map((pt, i) => (
                <div key={i} className="manufacturing-quality-facility-card__point">
                    <span className="manufacturing-quality-facility-card__point-bullet">
                        •
                    </span>
                    <span className="manufacturing-quality-facility-card__point-text">
                        {pt}
                    </span>
                </div>
            ))}

            <div className="manufacturing-quality-facility-card__certs">
                <div className="manufacturing-quality-facility-card__certs-heading">
                    CERTIFIED BY
                </div>
                <div className="manufacturing-quality-facility-card__certs-list">
                    {facility.certs.map((c) => (
                        <span
                            key={c}
                            className="manufacturing-quality-facility-card__cert-tag"
                        >
                            {c}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );

    return (
        <div
            className={`manufacturing-quality-facility-card scroll-reveal${reverse ? " manufacturing-quality-facility-card--reverse" : ""
                }`}
        >
            {imageBlock}
            {textBlock}
        </div>
    );
};

// ══════════════════════════════════════════════════════════════════════════════
// DATA
// ══════════════════════════════════════════════════════════════════════════════
const facilities = [
    {
        name: "Viyash Scientific Limited, Unit-I, MIDC Taloja",
        address:
            "Plot No. 1-A/2 and 1-A/3, M.I.D.C., Taloja Industrial Area, Panvel, Raigad, Maharashtra – 410208, India",
        points: [
            "Containment facility for in-house manufacturing of high potent (OEB 4/5) and cytotoxic APIs",
            "Capacity: 39 KL",
        ],
        certs: ["USFDA", "EU-GMP", "PMDA", "TGA", "MFDS", "WHO-GMP"],
        images: [ViyashScientificUnit1Img1, ViyashScientificUnit1Img2]
    },

    {
        name: "Viyash Scientific Limited, Unit-II, Visakhapatnam",
        address:
            "Plot No. 28, Sy. No. 1, 3, 9 & 26, Thanam Village, Parawada Mandal, Visakhapatnam – 531019, AP, India",
        points: [
            "Containment facility for in-house manufacturing of cytotoxic APIs",
            "Capacity: 290 KL",
        ],
        certs: ["USFDA", "EU-GMP", "WHO-GMP"],
        images: [ViyashScientificUnit2Img1, ViyashScientificUnit2Img2, ViyashScientificUnit2Img3, ViyashScientificUnit2Img4, ViyashScientificUnit2Img5],
    },

    {
        name: "Viyash Scientific Limited, Unit–III",
        address:
            "Sy. No. 353, 354 & 374, Domadugu (Village), Gummadidala (Mandal), Sangareddy (Dist.) - 502313, Telangana State, India.",
        points: [
            "Operates in accordance with cGMP",
            "Capacity: 80 KL",
        ],
        certs: ["USFDA", "EU-GMP", "MFDS", "WHO – GENEVA", "WHO-GMP"],
        images: [ViyashScientificUnit3Img1, ViyashScientificUnit3Img2, ViyashScientificUnit3Img3],
    },

    {
        name: "Viyash Scientific Limited, Unit-IV, Nalgonda",
        address:
            "Sy. No.: 163, 163/A, 164/A, Pittampally (Village), Chityala (Mandal), Nalgonda (Dist.) - 508114, Telangana State, India.",
        points: [
            "Expertise in Grignard, Acid Derivatives carbonylation, Iron Complex reactions, Reduction reactions in Catalytic Media, Cyanation reactions and Enzymatic Resolution reactions",
            "Capacity: 314 KL",
        ],
        certs: ["USFDA", "EU-GMP", "WHO-GMP"],
        images: [ViyashScientificUnit4Img1, ViyashScientificUnit4Img2, ViyashScientificUnit4Img3, ViyashScientificUnit4Img4, ViyashScientificUnit4Img5],
    },

    {
        name: "Viyash Scientific Limited, Unit-V, Jeedimetla",
        address:
            "Plot No: 25/B, Phase-III, IDA, Jeedimetla (V), Quthbullapur (M), Medchal-Malkajgiri district - 500055, Telangana state, INDIA. Telephone: +91-40-23191337",
        points: [
            "Expertise in Polymorphic forms",
            "Capacity: 137 KL",
        ],
        certs: ["USFDA", "EU-GMP", "ANVISA", "MFDS", "COFEPRIS", "WHO – GENEVA", "WHO-GMP"],
        images: [ViyashScientificUnit5Img1, ViyashScientificUnit5Img2, ViyashScientificUnit5Img3, ViyashScientificUnit5Img4, ViyashScientificUnit5Img5, ViyashScientificUnit5Img6],
    },

    {
        name: "Viyash Scientific Limited, Unit-VI, Choutuppal",
        address:
            "Sy. No. 744, 745, 750, 751, 752 & 753, Mandolla gudem Village, Choutuppal Mandal, Yadadri Dist-508252, Telangana, INDIA, Telephone: +91-40-23635097",
        points: [
            "Expertise in Nitration reactions, Reduction reactions in Catalytic Media",
            "Capacity: 490 KL",
        ],
        certs: ["USFDA", "ANVISA", "WHO-GMP"],
        images: [ViyashScientificUnit6Img1, ViyashScientificUnit6Img2, ViyashScientificUnit6Img3],
    },

    {
        name: "Viyash Scientific Limited, Unit-VII, Choutuppal",
        address:
            "Sy. No. 501, 506, 507, Koyalagudem Village, Choutuppal, Yadadri Bhuvanagiri (Dist.) - 508252 Telangana State, India.",
        points: [
            "Expertise in Bromination, Cyanidation, Chlorination, Condensation, Hydrogenation, Reduction, Acetylation, Esterification, Hydrolysis and Friedel-Crafts Reactions",
            "Capacity: 412 KL",
        ],
        certs: ["USFDA"],
        images: [ViyashScientificUnit7Img1, ViyashScientificUnit7Img2],
    },

    {
        name: "Viyash Scientific Limited, Unit-VIII, Bollaram",
        address:
            "Plot No: 3, 4 & 5, First Cross, IDA Bollaram Akrich Industrial Estate, Bollaram, Medak - 502325, Telangana State, India.",
        points: [
            "Expertise in Grignard, Coupling, Bromination, Hydrolysis, Reduction, Chlorination, Condensation, Acetylation, Friedel-Crafts, Decarboxylation, Demethylation and Oxidation Reactions.",
            "Capacity: 266 KL",
        ],
        certs: ["USFDA"],
        images: [ViyashScientificUnit8Img1, ViyashScientificUnit8Img2],
    },

    {
        name: "Viyash Scientific Limited, Unit-IX, Mahad",
        address:
            "4F2R+JH6, Mahad, Raigad, Maharashtra 402302, India",
        points: [
            "API facility with reactor capacity of 80KL with 2 clean rooms",
            "Certifications: ISO14001 and ISO45001 Audited and approved by top 10 vet MNCs for GMP and EHS",
            "Capacity: 80 KL",
        ],
        certs: ["EU GMP", "COFEPRIS Mexico"],
        images: [ViyashScientificUnit9Img1],
    },

    {
        name: "Alivira Vizag",
        address:
            "Plot No:104-109, 112, 113, JNPC, Special Economic Zone, Paravada Mandal, Visakhapatnam, Andhra Pradesh, 531019, India",
        points: [
            "API facility with reactor capacity of 290 KL with 10 clean rooms",
            "Capacity: 290 KL",
            "Audited and approved by top 10 veterinary MNCs for GMP and EHS",
        ],
        certs: ["US FDA", "EU GMP", "WHO-Geneva"],
        images: [AliviraVizagImg],
    },

    {
        name: "Alivira Ambernath",
        address:
            "A 68, MIDC Rd, Anand Nagar, Ind. Area, Ambernath, Maharashtra 421506, India",
        points: [
            "Capabilities: Sterile granules",
            "Dosage forms: Oral solutions/suspensions, powders, and premixes",
            "Capacity: 80 KL",
        ],
        certs: ["cGMP", "India", "Uganda", "Ethiopia", "Kenya"],
        images: [AliviraAmbernathImg],
    },
];

const intlFacilities = [
    {
        name: "Alivira Laboratorios Karizoo",
        flag: ESFlag,
        address:
            "Carrer de les Borges Blanques, 21-25, 08140, Barcelona, Spain",
        points: [
            "Capabilities: Dedicated beta-lactam powder block & nutritional line",
            "Dosage forms: Oral solutions/suspensions, powders and premixes",
        ],
        approvals: ["EUOMP"],
        bg: "#FFFAE7",
        border: "#FFDD5D",
    },
    {
        name: "Alivira Saúde Animal",
        flag: BRFlag,
        address:
            "R Queiroz Jr - Rua João Baptista de Queiroz Júnior, 447 - Jardim Myriam Moreira da Costa, Campinas - SP, 13098-415, Brazil",
        points: [
            "Capabilities: Dedicated on macrolides, quinolones, lincosamides, anti-inflammatory NSAIDs & additives and nutritional supplements",
            "Dosage forms: Powders, premixes, solutions, suspensions, paste, tablets",
        ],
        approvals: ["MAPA"],
        bg: "#E1FFF1",
        border: "#45FAA5",
    },
    {
        name: "Provet Veteriner Ürünleri - Ankara Şube",
        flag: TRFlag,
        address:
            "Çekirdeksiz Polatlı Organize Sanayi Sitesi 210 Cad, Çekirdeksiz OSB, No:7, 06900 Polatlı/Ankara, Türkiye",
        points: [
            "Capabilities: Beta-lactam block, Hormones",
            "Dosage forms: Sterile suspensions & Injectable, dry powder, aerosols, Intramammaries, pour-on/spot-on, oral solutions/suspensions",
        ],
        approvals: ["EUOMP", "Turkish GMP"],
        bg: "#FFF1F2",
        border: "#FF838A",
    },
    {
        name: "Appco Pharma LLC",
        flag: USFlag,
        address:
            "262 Old Newbrunswick Road, Suite N, Piscataway, NJ 08854. Telephone: (732) 271 8300, (732) 469 1000",
        points: [],
        approvals: ["USFDA"],
        bg: "#EFF6FF",
        border: "#BFDBFE",
    },
];

const TABS = [
    "Global Footprint",
    "Manufacturing Sites",
    "Capabilities",
    "Quality Systems",
    "R&D & Process Safety",
];

const TAB_TARGETS = [
    "global-footprint",
    "our-facilities",
    "capabilities",
    "quality-systems",
    "rd-safety",
];

const HERO_STATS = [
    { val: "15", lab: "Manufacturing Sites" },
    { val: "10+5", lab: "API + FDF Facilities" },
    { val: "10", lab: "USFDA Approved Units" },
    { val: "85%+", lab: "Backward Integrated" },
    { val: "3000+", lab: "Skilled Employees" },
];

const NETWORK_HIGHLIGHTS = [
    "10 API manufacturing sites across India",
    "100% USFDA approved manufacturing network",
    "1–1,000 kg batch size flexibility",
    "Semi-automated pilot plant infrastructure",
    "ISO Class-8 clean room isolators",
    "Preparative HPLC scale-up capability",
    "Zero Liquid Discharge (ZLD) facilities",
    "Continuous flow chemistry infrastructure",
];

const REG_CERTS = [
    "FDA - US FOOD & DRUG ADMINISTRATION",

    "EDQM",
    "ANVISA",
    "NMPA CHINA",
    "PMDA",
    "MFDS (KOREA – Ministry of Food and Drug Safety)",
    "COFEPRIS",
    "TGA",
    "Health Canada",
    "WHO-GMP",
    "ISO 14001 Certified",
    "ISO 45001 Certified"
];

const MAP_LEGEND = [
    // { color: "#dd3537", label: "Multi-unit cluster" },
    // { color: "#3B82F6", label: "API site" },
    // { color: "#10B981", label: "Multi-facility site" },
];

const CAPABILITY_CARDS = [
    {
        icon: manufacturingQualityDiversifiedIcon,
        title: "Diversified & Flexible Network",
        points: [
            { text: "10 API + 5 FDF Facilities", icon: Icon1card1 },
            { text: "Fully backward-integrated value chain", icon: Icon2card1 },
            { text: "85%+ backward integration", icon: Icon3card1 },
            { text: "1 kg to 1,000 kg batch flexibility", icon: Icon4card1 },
            { text: "Multi-site supply redundancy", icon: Icon5card1 },
            { text: "Dedicated animal health suites", icon: Icon6card1 },
        ],
    },
    {
        icon: manufacturingQualityProvenIcon,
        title: "Proven Technical Capabilities",
        points: [
            { text: "Critical & hazardous chemistry handling", icon: Icon1card2 },
            { text: "Cytotoxic isolators (OEB 4/5)", icon: Icon2card2 },
            { text: "Preparative HPLC at scale", icon: Icon3card2 },
            { text: "Continuous flow chemistry", icon: Icon4card2 },
            { text: "Chiral & asymmetric synthesis", icon: Icon5card2 },
            { text: "Polymorph / solid-state engineering", icon: Icon6card2 },
        ],
    },
    {
        icon: manufacturingQualityGlobalIcon,
        title: "Global Accreditations",
        points: [
            { text: "10 USFDA approved units", icon: Icon1card3 },
            { text: "EU GMP certified facilities", icon: Icon2card3 },
            { text: "WHO GMP approved", icon: Icon3card3 },
            { text: "PMDA & KFDA filings", icon: Icon4card3 },
            { text: "COFEPRIS (Mexico) approved", icon: Icon5card3 },
            { text: "ANVISA (Brazil) certified", icon: Icon6card3 },
        ],
    },
];

const BOTTOM_STATS = [
    { val: "100%", sub: "USFDA Approved Network" },
    { val: "9", sub: "Facilities approved by global regulatory bodies" },
    { val: "55+", sub: "Granted Patents" },
    { val: "ZLD", sub: "Zero Liquid Discharge Facilities" },
];

// ══════════════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ══════════════════════════════════════════════════════════════════════════════
const ManufacturingQuality = () => {
    const [activeTab, setActiveTab] = useState(0);

    // ========================
    //  SCROLL REVEAL ANIMATIONS
    // ========================
    useEffect(() => {
        // Pre-mark all stagger children as hidden
        document.querySelectorAll("[data-stagger]").forEach((grid) => {
            Array.from(grid.children).forEach((child) => {
                child.classList.add("anim-child");
            });
        });

        // Observer for stagger grids — each child animates individually
        const staggerObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        Array.from(entry.target.children).forEach((child, i) => {
                            child.style.animationDelay = `${i * 0.13}s`;
                            child.classList.add(
                                i % 2 === 0 ? "anim-from-left" : "anim-from-right"
                            );
                        });
                        staggerObserver.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12 }
        );

        document
            .querySelectorAll("[data-stagger]")
            .forEach((el) => staggerObserver.observe(el));

        // Observer for section-level reveals
        const sectionObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("visible");
                        sectionObserver.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.06 }
        );

        document
            .querySelectorAll(".scroll-reveal, .sr-left, .sr-right")
            .forEach((el) => sectionObserver.observe(el));

        return () => {
            staggerObserver.disconnect();
            sectionObserver.disconnect();
        };
    }, []);

    const qualitySteps = [
        {
            icon: qualityStepsIcon1,
            title: "Raw Material Testing",
            sub: "Identity, potency & purity",
            color: "#003D7A",
        },
        {
            icon: qualityStepsIcon2,
            title: "Synthesis & Process",
            sub: "In-process monitoring",
            color: "#0070C0",
        },
        {
            icon: qualityStepsIcon3,
            title: "In-Process Testing",
            sub: "Real-time QC checkpoints",
            color: "#00829A",
        },
        {
            icon: qualityStepsIcon4,
            title: "Validation",
            sub: "PPQ & process validation",
            color: "#00956A",
        },
        {
            icon: qualityStepsIcon5,
            title: "Final Release",
            sub: "Certificate of Analysis",
            color: "#00A651",
        },
        {
            icon: qualityStepsIcon6,
            title: "Distribution",
            sub: "Cold chain & GDP",
            color: "#007A40",
        },
    ];

    const infoCards = [
        {
            icon: infoCardsIcon1,
            title: "Regulatory Approvals",
            desc: "USFDA, EU GMP, WHO, PMDA, COFEPRIS, KFDA — consistent multi-agency approval track record",
        },
        {
            icon: infoCardsIcon2,
            title: "Sustainable Quality Systems",
            desc: "Zero Liquid Discharge facilities, Zero Hazardous Waste Landfill policy across all sites",
        },
        {
            icon: infoCardsIcon3,
            title: "ISO 14001 & 45001",
            desc: "Environmental & occupational health management systems certified across all major sites",
        },
        {
            icon: infoCardsIcon4,
            title: "Trained Quality Workforce",
            desc: "3,000+ skilled employees trained in cGMP, data integrity, and quality culture programmes",
        },
    ];

    const sciStats = [
        {
            val: "200+",
            label: "Scientists",
            sub: "20+ PhDs",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <g clip-path="url(#clip0_468_7148)">
                        <path d="M13.3334 17.5V15.8333C13.3334 14.9493 12.9822 14.1014 12.3571 13.4763C11.732 12.8512 10.8841 12.5 10.0001 12.5H5.00008C4.11603 12.5 3.26818 12.8512 2.64306 13.4763C2.01794 14.1014 1.66675 14.9493 1.66675 15.8333V17.5" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M7.50008 9.16667C9.34103 9.16667 10.8334 7.67428 10.8334 5.83333C10.8334 3.99238 9.34103 2.5 7.50008 2.5C5.65913 2.5 4.16675 3.99238 4.16675 5.83333C4.16675 7.67428 5.65913 9.16667 7.50008 9.16667Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M18.3333 17.5001V15.8334C18.3327 15.0948 18.0869 14.3774 17.6344 13.7937C17.1819 13.2099 16.5484 12.793 15.8333 12.6084" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M13.3333 2.6084C14.0503 2.79198 14.6858 3.20898 15.1396 3.79366C15.5935 4.37833 15.8398 5.09742 15.8398 5.83757C15.8398 6.57771 15.5935 7.2968 15.1396 7.88147C14.6858 8.46615 14.0503 8.88315 13.3333 9.06673" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_468_7148">
                            <rect width="20" height="20" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            ),
        },
        {
            val: "13",
            label: "Chemical Labs",
            sub: "Research grade",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M11.6667 1.66699V6.66699C11.6666 6.94656 11.7368 7.22167 11.8709 7.46699L16.4626 15.867C16.6014 16.1208 16.6719 16.4065 16.6669 16.6958C16.6619 16.9851 16.5816 17.2681 16.4341 17.517C16.2865 17.7659 16.0767 17.9721 15.8252 18.1153C15.5738 18.2585 15.2894 18.3337 15.0001 18.3337H5.00006C4.71071 18.3337 4.42632 18.2585 4.17489 18.1153C3.92345 17.9721 3.71362 17.7659 3.56605 17.517C3.41848 17.2681 3.33825 16.9851 3.33326 16.6958C3.32826 16.4065 3.39867 16.1208 3.53756 15.867L8.12923 7.46699C8.2633 7.22167 8.33351 6.94656 8.33339 6.66699V1.66699" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M5.37744 12.5H14.6224" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.08325 1.66699H12.9166" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),
        },
        {
            val: "20",
            label: "Analytical Labs",
            sub: "ICH compliant",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M5 15H11.6667" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M2.5 18.333H17.5" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M11.6666 18.3337C13.2137 18.3337 14.6974 17.7191 15.7914 16.6251C16.8853 15.5312 17.4999 14.0474 17.4999 12.5003C17.4999 10.9532 16.8853 9.4695 15.7914 8.37554C14.6974 7.28157 13.2137 6.66699 11.6666 6.66699H10.8333" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.5 11.667H9.16667" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7.49992 10C7.05789 10 6.63397 9.8244 6.32141 9.51184C6.00885 9.19928 5.83325 8.77536 5.83325 8.33333V5H10.8333V8.33333C10.8333 8.77536 10.6577 9.19928 10.3451 9.51184C10.0325 9.8244 9.60861 10 9.16659 10H7.49992Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M10.0001 5.00033V2.50033C10.0001 2.27931 9.91228 2.06735 9.756 1.91107C9.59972 1.75479 9.38776 1.66699 9.16675 1.66699H7.50008C7.27907 1.66699 7.06711 1.75479 6.91083 1.91107C6.75455 2.06735 6.66675 2.27931 6.66675 2.50033V5.00033" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),
        },
        {
            val: "64",
            label: "Fume Hoods",
            sub: "Full containment",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M3.33337 11.6662C3.17567 11.6668 3.02106 11.6226 2.8875 11.5387C2.75393 11.4549 2.6469 11.3349 2.57883 11.1926C2.51076 11.0504 2.48445 10.8917 2.50295 10.7351C2.52146 10.5785 2.58402 10.4304 2.68337 10.3079L10.9334 1.8079C10.9953 1.73647 11.0796 1.6882 11.1725 1.67101C11.2655 1.65382 11.3615 1.66874 11.4448 1.71332C11.5281 1.7579 11.5939 1.82948 11.6311 1.91632C11.6684 2.00317 11.6751 2.10011 11.65 2.19123L10.05 7.2079C10.0029 7.33417 9.98701 7.47 10.0039 7.60374C10.0207 7.73748 10.0698 7.86513 10.1468 7.97575C10.2238 8.08638 10.3265 8.17666 10.4461 8.23887C10.5657 8.30107 10.6986 8.33334 10.8334 8.3329H16.6667C16.8244 8.33236 16.979 8.37658 17.1126 8.46042C17.2461 8.54425 17.3532 8.66427 17.4212 8.80652C17.4893 8.94877 17.5156 9.10741 17.4971 9.26402C17.4786 9.42062 17.4161 9.56877 17.3167 9.69123L9.0667 18.1912C9.00482 18.2627 8.92048 18.3109 8.82755 18.3281C8.73461 18.3453 8.6386 18.3304 8.55526 18.2858C8.47192 18.2412 8.40621 18.1697 8.36892 18.0828C8.33163 17.996 8.32497 17.899 8.35003 17.8079L9.95003 12.7912C9.99721 12.665 10.0131 12.5291 9.99621 12.3954C9.97936 12.2617 9.93032 12.134 9.85329 12.0234C9.77627 11.9128 9.67356 11.8225 9.55397 11.7603C9.43439 11.6981 9.3015 11.6658 9.1667 11.6662H3.33337Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),
        },
        {
            val: "190+",
            label: "Patents Filed",
            sub: "Globally",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M18.3333 5.83301L11.25 12.9163L7.08329 8.74967L1.66663 14.1663" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M13.3334 5.83301H18.3334V10.833" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),
        },
        {
            val: "55+",
            label: "Patents Granted",
            sub: "Active IP portfolio",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M12.8975 10.7412L14.16 17.8462C14.1742 17.9299 14.1624 18.0159 14.1264 18.0927C14.0903 18.1695 14.0317 18.2335 13.9583 18.276C13.8849 18.3186 13.8003 18.3378 13.7157 18.331C13.6311 18.3241 13.5507 18.2917 13.485 18.2379L10.5017 15.9987C10.3577 15.8911 10.1827 15.833 10.003 15.833C9.82318 15.833 9.64822 15.8911 9.5042 15.9987L6.51587 18.237C6.4503 18.2907 6.36992 18.3232 6.28545 18.33C6.20098 18.3368 6.11643 18.3177 6.04309 18.2753C5.96975 18.2328 5.9111 18.169 5.87497 18.0923C5.83884 18.0157 5.82694 17.9298 5.84087 17.8462L7.10254 10.7412" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M10 11.667C12.7614 11.667 15 9.42842 15 6.66699C15 3.90557 12.7614 1.66699 10 1.66699C7.23858 1.66699 5 3.90557 5 6.66699C5 9.42842 7.23858 11.667 10 11.667Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            ),
        },
    ];

    const instruments = [
        "HPLC",
        "GC",
        "LC-MS/MS",
        "GC-MS",
        "DSC",
        "ARC Calorimeter",
        "MIE",
        "MIT",
        "pXRD",
        "FT-IR",
        "FT-Raman",
        "NMR",
    ];

    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <div className="manufacturing-quality-wrapper">
            {/* ══════════════════════════════════════════════════════════════════════
          SECTION 1 – HERO
          ══════════════════════════════════════════════════════════════════════ */}
            <section className="manufacturing-quality-section1">
                <img
                    src={section1Manufacturingfacilityhero}
                    alt="Manufacturing facility hero"
                    className="manufacturing-quality-section1__bg-image"
                />
                <div className="manufacturing-quality-section1__overlay" />

                <div className="manufacturing-quality-section1__content sr-left">
                    <h1 className="manufacturing-quality-section1__title">
                        Manufacturing &amp; Quality
                    </h1>
                    <p className="manufacturing-quality-section1__subtitle">
                        Integrated, Globally Accredited, Backward-Integrated Manufacturing
                        Network
                    </p>
                    <p className="manufacturing-quality-section1__description">
                        From milligram synthesis to multi-tonne commercial batches — 100%
                        <br />
                        USFDA approved, globally compliant, and science-driven at every
                        step.
                    </p>

                    {/* Stats Row */}
                    <div className="manufacturing-quality-section1__stats">
                        {HERO_STATS.map((s) => (
                            <div
                                key={s.lab}
                                className="manufacturing-quality-section1__stat-card"
                            >
                                <div className="manufacturing-quality-section1__stat-value">
                                    <AnimatedCounter value={s.val} className="manufacturing-quality-section1__stat-value" />
                                </div>
                                <div className="manufacturing-quality-section1__stat-label">
                                    {s.lab}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* CTA */}
                    <a
                        href="#our-facilities"
                        onClick={(e) => {
                            e.preventDefault();
                            scrollTo("our-facilities");
                        }}
                        className="manufacturing-quality-section1__cta"
                    >
                        Explore Our Facilities
                        <svg
                            width="16"
                            height="16"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth="2"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M17 8l4 4m0 0l-4 4m4-4H3"
                            />
                        </svg>
                    </a>
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════════════
          BREADCRUMB
          ══════════════════════════════════════════════════════════════════════ */}
            {/* ================= Breadcrumb ================= */}
            <div className="cdmo-breadcrumb-container">
                <div className="cdmo-breadcrumb-wrapper">

                    <a href="/home" className="cdmo-breadcrumb-link cdmo-home-link">
                        <svg className="cdmo-breadcrumb-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M10 14V8.66667C10 8.48986 9.92976 8.32029 9.80474 8.19526C9.67971 8.07024 9.51014 8 9.33333 8H6.66667C6.48986 8 6.32029 8.07024 6.19526 8.19526C6.07024 8.32029 6 8.48986 6 8.66667V14"
                                stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M2 6.66667C1.99995 6.47271 2.04222 6.28108 2.12386 6.10514C2.20549 5.92921 2.32453 5.7732 2.47267 5.648L7.13933 1.64867C7.37999 1.44527 7.6849 1.33368 8 1.33368C8.3151 1.33368 8.62001 1.44527 8.86067 1.64867L13.5273 5.648C13.6755 5.7732 13.7945 5.92921 13.8761 6.10514C13.9578 6.28108 14 6.47271 14 6.66667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V6.66667Z"
                                stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Home
                    </a>

                    <span className="cdmo-breadcrumb-separator">›</span>

                    <span className="cdmo-breadcrumb-current">Manufacturing &amp; Quality</span>

                </div>
            </div>

            {/* ══════════════════════════════════════════════════════════════════════
          TABS
          ══════════════════════════════════════════════════════════════════════ */}
            <div className="manufacturing-quality-tabs">
                {TABS.map((tab, i) => (
                    <button
                        key={tab}
                        onClick={() => {
                            setActiveTab(i);
                            scrollTo(TAB_TARGETS[i]);
                        }}
                        className={`manufacturing-quality-tabs__button${activeTab === i
                            ? " manufacturing-quality-tabs__button--active"
                            : ""
                            }`}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            {/* ══════════════════════════════════════════════════════════════════════
          SECTION 2 – GLOBAL FOOTPRINT
          ══════════════════════════════════════════════════════════════════════ */}
            <section
                id="global-footprint"
                className="manufacturing-quality-section2"
            >
                <div className="manufacturing-quality-section2__header scroll-reveal">
                    <h2 className="manufacturing-quality-section2__title">
                        India-Rooted, Globally Accredited
                    </h2>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p className="manufacturing-quality-section2__subtitle">
                        Strategically located facilities in Maharashtra &amp; Andhra
                        Pradesh/Telangana
                    </p>
                </div>

                <div className="manufacturing-quality-section2__grid">
                    {/* ── Map ── */}
                    <div className="manufacturing-quality-section2__map-wrapper sr-left">
                        <div className="manufacturing-quality-section2__map-bar">
                            <span className="manufacturing-quality-section2__map-bar-label">
                                MANUFACTURING NETWORK
                            </span>
                            <span className="manufacturing-quality-section2__map-bar-title">
                                India Operations
                            </span>
                        </div>

                        <img
                            src={manufacturingQualityMapSection2}
                            alt="India Map"
                            className="manufacturing-quality-section2__map-image"
                        />

                        {/* Legend */}
                        <div className="manufacturing-quality-section2__map-legend">
                            {MAP_LEGEND.map((l) => (
                                <div
                                    key={l.label}
                                    className="manufacturing-quality-section2__map-legend-item"
                                >
                                    <span
                                        className="manufacturing-quality-section2__map-legend-dot"
                                        style={{ background: l.color }}
                                    />
                                    <span className="manufacturing-quality-section2__map-legend-text">
                                        {l.label}
                                    </span>
                                </div>
                            ))}
                        </div>

                        {/* Badge */}
                        <div className="manufacturing-quality-section2__map-badge">
                            <div className="manufacturing-quality-section2__map-badge-value">
                                10
                            </div>
                            <div className="manufacturing-quality-section2__map-badge-label">
                                API Sites
                            </div>
                        </div>
                    </div>

                    {/* ── Right Column ── */}
                    <div className="manufacturing-quality-section2__right-col sr-right">
                        {/* Network Highlights */}
                        <div className="manufacturing-quality-section2__highlights">
                            <div className="manufacturing-quality-section2__highlights-header">
                                <img
                                    src={manufacturingNetworkHighlightIcons}
                                    alt="Network Highlights Icon"
                                    style={{ height: "32px" }}
                                />
                                <span className="manufacturing-quality-section2__highlights-title">
                                    Network Highlights
                                </span>
                            </div>

                            <div className="manufacturing-quality-network-list" data-stagger="true">
                                {NETWORK_HIGHLIGHTS.map((pt) => (
                                    <div
                                        key={pt}
                                        className="manufacturing-quality-section2__highlight-row"
                                    >
                                        <span className="manufacturing-quality-section2__highlight-dot" />
                                        <span className="manufacturing-quality-section2__highlight-text">
                                            {pt}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Regulatory Certifications */}
                        <div className="manufacturing-quality-section2__certs">
                            <div className="manufacturing-quality-section2__certs-heading">
                                REGULATORY CERTIFICATIONS
                            </div>
                            <div className="manufacturing-quality-section2__certs-list" data-stagger="true">
                                {REG_CERTS.map((c) => (
                                    <span
                                        key={c}
                                        className="manufacturing-quality-section2__cert-tag"
                                    >
                                        <img
                                            src={manufacturingQualitySection2CertsListIcon}
                                            alt=""
                                            className="manufacturing-quality-section2__cert-tag-icon"
                                        />
                                        {c}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════════════
          SECTION 3 – OUR FACILITIES
          ══════════════════════════════════════════════════════════════════════ */}
            <section id="our-facilities" className="manufacturing-quality-section3">
                <div className="manufacturing-quality-section2__header scroll-reveal">
                    <h2 className="manufacturing-quality-section2__title">
                        Our Facilities
                    </h2>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p className="manufacturing-quality-section2__subtitle">
                        Built for Scale, Trusted
                        for Quality
                    </p>
                </div>

                {/* Category Label */}
                <div className="manufacturing-quality-section3__category">
                    <span className="manufacturing-quality-section3__category-pill">
                        API MANUFACTURING — INDIA
                    </span>
                </div>

                {/* Facility Cards */}
                <div className="manufacturing-quality-section3__list">
                    {facilities.map((f, i) => (
                        <FacilityCard key={f.name} facility={f} reverse={i % 2 !== 0} />
                    ))}
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════════════
          SECTION 4 – INTERNATIONAL PRESENCE
          ══════════════════════════════════════════════════════════════════════ */}
            <section className="manufacturing-quality-section4">
                <div className="manufacturing-quality-section4__category">
                    <span className="manufacturing-quality-section4__category-pill">
                        INTERNATIONAL PRESENCE
                    </span>
                </div>

                <div className="manufacturing-quality-section4__grid" data-stagger="true">
                    {intlFacilities.map((f) => (
                        <div
                            key={f.name}
                            className="manufacturing-quality-section4__card"
                            style={{ background: f.bg, border: `1px solid ${f.border}` }}
                        >
                            <div className="manufacturing-quality-section4__card-header">
                                <h3 className="manufacturing-quality-section4__card-name">
                                    {f.name}
                                </h3>
                                <img
                                    src={f.flag}
                                    alt="Flag"
                                    className="manufacturing-quality-section4__card-flag-img"
                                />
                            </div>

                            <div className="manufacturing-quality-section4__card-address">
                                <LocationIcon size={12} color="#9CA3AF" />
                                <span className="manufacturing-quality-section4__card-address-text">
                                    {f.address}
                                </span>
                            </div>

                            {f.points.map((pt, i) => (
                                <div
                                    key={i}
                                    className="manufacturing-quality-section4__card-point"
                                >
                                    <span className="manufacturing-quality-section4__card-point-bullet">
                                        •
                                    </span>
                                    <span className="manufacturing-quality-section4__card-point-text">
                                        {pt}
                                    </span>
                                </div>
                            ))}

                            {f.approvals && f.approvals.length > 0 && (
                                <div className="manufacturing-quality-section4__card-approvals">
                                    <div className="manufacturing-quality-section4__card-approvals-heading">
                                        APPROVALS
                                    </div>
                                    <div className="manufacturing-quality-section4__card-approvals-list">
                                        {f.approvals.map((a) => (
                                            <span
                                                key={a}
                                                className="manufacturing-quality-section4__card-approval-tag"
                                            >
                                                {a}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════════════
          SECTION 5 – CAPABILITIES
          ══════════════════════════════════════════════════════════════════════ */}
            <section id="capabilities" className="manufacturing-quality-section5">
                <div className="manufacturing-quality-section2__header scroll-reveal">
                    <h2 className="manufacturing-quality-section2__title">
                        Built for Complexity
                    </h2>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p className="manufacturing-quality-section2__subtitle">
                        Infrastructure and expertise to handle the most demanding pharmaceutical chemistries
                    </p>
                </div>

                {/* Capability Cards */}
                <div className="manufacturing-quality-section5__grid" data-stagger="true">
                    {CAPABILITY_CARDS.map((col) => (
                        <div
                            key={col.title}
                            className="manufacturing-quality-section5__cap-card"
                        >
                            <div className="manufacturing-quality-section5__cap-card-header">
                                <div className="manufacturing-quality-section5__cap-card-icon">
                                    <img src={col.icon} alt="" />
                                </div>
                                <span className="manufacturing-quality-section5__cap-card-title">
                                    {col.title}
                                </span>
                            </div>

                            <div className="manufacturing-quality-section5__cap-card-body">
                                {col.points.map((pt, i) => (
                                    <div
                                        key={i}
                                        className="manufacturing-quality-section5__cap-card-row"
                                    >
                                        <div className="manufacturing-quality-section5__cap-card-point-icon-wrapper">
                                            <img src={pt.icon} alt="" className="manufacturing-quality-section5__cap-card-point-icon" />
                                        </div>
                                        <span className="manufacturing-quality-section5__cap-card-text">
                                            {pt.text}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Bottom Stats Bar */}
                <div className="manufacturing-quality-section5__stats-bar" data-stagger="true">
                    {BOTTOM_STATS.map((s, i) => (
                        <div
                            key={s.val}
                            className="manufacturing-quality-section5__stat"
                        >
                            <div className="manufacturing-quality-section5__stat-value">
                                <AnimatedCounter value={s.val} className="manufacturing-quality-section5__stat-value" />
                            </div>
                            <div className="manufacturing-quality-section5__stat-label">
                                {s.sub}
                            </div>
                        </div>
                    ))}
                </div>
            </section>


            {/* ══════════════════════════════════════════════════════════════════════
          SECTION 6 – Quality at Every Step
          ══════════════════════════════════════════════════════════════════════ */}
            <section id="quality-systems" className="manufacturing-quality-section6">
                {/* Header */}
                <div className="manufacturing-quality-section2__header scroll-reveal">
                    <h2 className="manufacturing-quality-section2__title">
                        Quality at Every Step
                    </h2>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p className="manufacturing-quality-section2__subtitle">
                        Robust, end-to-end quality management from raw material to patient
                    </p>
                </div>

                {/* Two-column layout */}
                <div className="manufacturing-quality-section6__grid">
                    {/* Left: Quality Assurance Process Flow */}


                    {/* Right: Image + 4 info cards */}
                    <div className="manufacturing-quality-section6__right-col sr-right">
                        {/* Image Card */}
                        <div className="manufacturing-quality-section6__image-card">
                            <img
                                src={QualityControlsImage}
                                alt="Quality Controls"
                                className="manufacturing-quality-section6__image-card-img"
                            />
                            <div className="manufacturing-quality-section6__image-card-overlay" />
                            <div className="manufacturing-quality-section6__image-card-text">
                                <div className="manufacturing-quality-section6__image-card-heading">
                                    Rigorous Quality Controls
                                </div>
                                <div className="manufacturing-quality-section6__image-card-desc">
                                    Across the entire value chain — from raw material to
                                    distribution
                                </div>
                            </div>
                        </div>

                        {/* 4 info rows */}
                        <div className="manufacturing-quality-section6__info-rows-container" data-stagger="true">
                            {infoCards.map((item) => (
                                <div
                                    key={item.title}
                                    className="manufacturing-quality-section6__info-row"
                                >
                                    <div className="manufacturing-quality-section6__info-row-icon">
                                        <img src={item.icon} alt="" />
                                    </div>
                                    <div>
                                        <div className="manufacturing-quality-section6__info-row-title">
                                            {item.title}
                                        </div>
                                        <div className="manufacturing-quality-section6__info-row-desc">
                                            {item.desc}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>


            {/* ══════════════════════════════════════════════════════════════════════
          SECTION 7 – The Science Behind the Scale
          ══════════════════════════════════════════════════════════════════════ */}
            <section id="rd-safety" className="manufacturing-quality-section7">
                {/* Header */}

                <div className="manufacturing-quality-section2__header scroll-reveal">
                    <h2 className="manufacturing-quality-section2__title">
                        The Science Behind the Scale
                    </h2>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    <p className="manufacturing-quality-section2__subtitle">
                        World-class research infrastructure enabling complex chemistry at
                        commercial scale
                    </p>
                </div>

                {/* 6 stat cards */}
                <div className="manufacturing-quality-section7__stats-grid" data-stagger="true">
                    {sciStats.map((s) => (
                        <div key={s.label} className="manufacturing-quality-section7__stat-card">
                            <div className="manufacturing-quality-section7__stat-card-icon">
                                {s.icon}
                            </div>
                            <div className="manufacturing-quality-section7__stat-card-val">
                                <AnimatedCounter value={s.val} className="manufacturing-quality-section7__stat-card-val" />
                            </div>
                            <div className="manufacturing-quality-section7__stat-card-label">
                                {s.label}
                            </div>
                            <div className="manufacturing-quality-section7__stat-card-sub">
                                {s.sub}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Bottom: Image + Instrumentation panel */}
                <div className="manufacturing-quality-section7__bottom-grid">
                    {/* Left: Image with overlay text */}
                    <div className="manufacturing-quality-section7__image-block sr-left">
                        <img
                            src={FirstShotChemistryImage}
                            alt="First-Shot Chemistry"
                            className="manufacturing-quality-section7__image-block-img"
                        />
                        <div className="manufacturing-quality-section7__image-block-overlay" />
                        <div className="manufacturing-quality-section7__image-block-text">
                            <div className="manufacturing-quality-section7__image-block-heading">
                                First-Shot OK Chemistry
                            </div>
                            <div className="manufacturing-quality-section7__image-block-desc">
                                Our scientists deliver right-first-time synthesis with deep
                                expertise in complex chemistries
                            </div>
                        </div>
                    </div>

                    {/* Right: white card with instrumentation grid + process safety */}
                    <div className="manufacturing-quality-section7__instrument-panel sr-right">
                        {/* Title row */}
                        <div className="manufacturing-quality-section7__instrument-panel-header">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M12.0833 1.66699V16.2503C12.0833 17.417 11.1666 18.3337 9.99996 18.3337C8.83329 18.3337 7.91663 17.417 7.91663 16.2503V1.66699" stroke="#003D7A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M7.08337 1.66699H12.9167" stroke="#003D7A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12.0833 13.333H7.91663" stroke="#003D7A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <span className="manufacturing-quality-section7__instrument-panel-title">
                                Analytical Instrumentation
                            </span>
                        </div>

                        {/* 3-col instrument buttons */}
                        <div className="manufacturing-quality-section7__instrument-grid" data-stagger="true">
                            {instruments.map((inst) => (
                                <div
                                    key={inst}
                                    className="manufacturing-quality-section7__instrument-tag"
                                >
                                    {inst}
                                </div>
                            ))}
                        </div>



                        {/* Process Safety row */}
                        <div className="manufacturing-quality-section7__safety-row">
                            <div className="manufacturing-quality-section7__safety-row-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M16.6667 10.8331C16.6667 14.9997 13.75 17.0831 10.2834 18.2914C10.1018 18.3529 9.90466 18.35 9.72504 18.2831C6.25004 17.0831 3.33337 14.9997 3.33337 10.8331V4.99972C3.33337 4.77871 3.42117 4.56675 3.57745 4.41047C3.73373 4.25419 3.94569 4.16639 4.16671 4.16639C5.83337 4.16639 7.91671 3.16639 9.36671 1.89972C9.54325 1.74889 9.76784 1.66602 10 1.66602C10.2322 1.66602 10.4568 1.74889 10.6334 1.89972C12.0917 3.17472 14.1667 4.16639 15.8334 4.16639C16.0544 4.16639 16.2663 4.25419 16.4226 4.41047C16.5789 4.56675 16.6667 4.77871 16.6667 4.99972V10.8331Z" stroke="#003D7A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div>
                                <div className="manufacturing-quality-section7__safety-row-title">
                                    Process Safety Infrastructure
                                </div>
                                <div className="manufacturing-quality-section7__safety-row-desc">
                                    Dedicated process safety lab with ARC, MIE, MIT for full thermal
                                    hazard evaluation — enabling safe scale-up of hazardous reactions
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ══════════════════════════════════════════════════════════════════════
          SECTION 8 – Final CTA
          ══════════════════════════════════════════════════════════════════════ */}
            <section className="manufacturing-quality-section8 scroll-reveal">
                <div className="manufacturing-quality-section8__content">
                    <h2 className="manufacturing-quality-section8__title">
                        Built for Scale. Trusted for Quality.
                    </h2>
                    <p className="manufacturing-quality-section8__subtitle">
                        With integrated facilities, regulatory excellence, and robust quality systems, Viyash
                        Scientific delivers reliability at every stage of the pharmaceutical value chain.
                    </p>

                    <div className="manufacturing-quality-section8__btns">
                        <a href="/contact" className="manufacturing-quality-section8__btn manufacturing-quality-section8__btn--primary">
                            Contact Manufacturing Team
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                                <polyline points="12 5 19 12 12 19"></polyline>
                            </svg>
                        </a>
                        <a href="/cdmo" className="manufacturing-quality-section8__btn manufacturing-quality-section8__btn--secondary">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
                                <g clip-path="url(#clip0_468_7282)">
                                    <path d="M1.33337 13.333C1.33337 13.6866 1.47385 14.0258 1.7239 14.2758C1.97395 14.5259 2.31309 14.6663 2.66671 14.6663H13.3334C13.687 14.6663 14.0261 14.5259 14.2762 14.2758C14.5262 14.0258 14.6667 13.6866 14.6667 13.333V5.33301L10 8.66634V5.33301L5.33337 8.66634V2.66634C5.33337 2.31272 5.1929 1.97358 4.94285 1.72353C4.6928 1.47348 4.35366 1.33301 4.00004 1.33301H2.66671C2.31309 1.33301 1.97395 1.47348 1.7239 1.72353C1.47385 1.97358 1.33337 2.31272 1.33337 2.66634V13.333Z" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M11.3334 12H12" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8 12H8.66667" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M4.66663 12H5.33329" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_468_7282">
                                        <rect width="16" height="16" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                            Explore CDMO Services
                        </a>
                    </div>
                </div>

                <div className="manufacturing-quality-section8__stats-row" data-stagger="true">
                    <div className="manufacturing-quality-section8__stat">
                        <div className="manufacturing-quality-section8__stat-val">
                            <AnimatedCounter value="15" />
                        </div>
                        <div className="manufacturing-quality-section8__stat-lab">Manufacturing Sites</div>
                    </div>
                    <div className="manufacturing-quality-section8__stat">
                        <div className="manufacturing-quality-section8__stat-val">
                            <AnimatedCounter value="100%" />
                        </div>
                        <div className="manufacturing-quality-section8__stat-lab">USFDA Approved Network</div>
                    </div>
                    <div className="manufacturing-quality-section8__stat">
                        <div className="manufacturing-quality-section8__stat-val">
                            <AnimatedCounter value="9" />
                        </div>
                        <div className="manufacturing-quality-section8__stat-lab">Facilities approved by global regulatory bodies</div>
                    </div>
                    <div className="manufacturing-quality-section8__stat">
                        <div className="manufacturing-quality-section8__stat-val">
                            <AnimatedCounter value="3000+" />
                        </div>
                        <div className="manufacturing-quality-section8__stat-lab">Skilled Professionals</div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ManufacturingQuality;